module.exports = __webpack_public_path__ + "img/image13.fe9784ff.png";